import axios from "axios";
import { setUserRole, setUserUsername } from "reducers";
import { API_URL, getHeaderWithAuthorization } from "./API";
import { TThunkDispatch } from "store";
import { removeToken } from "utils";
import { setUserId, setUserName } from "reducers/userInfo";
import { setCookie } from "../utils/localStorage.util";

export const userLoginActionCreator = ({
  login,
  password,
  handleError,
  pushToPath,
}: {
  login: string;
  password: string;
  handleError: () => void;
  pushToPath: (path: string) => void;
}) => {
  return (dispatch: TThunkDispatch) =>
    axios
      .post(API_URL + "v1/auth/login", {
        username: login,
        password: password,
      })
      .then(({ data }) => {
        setCookie("authJwt", data.token, {
          secure: true,
          "max-age": 3600 * 48,
        });
        // centrifuge.setToken(data.token);
        dispatch(getUserInfoActionCreator(pushToPath));
        pushToPath("/");
      })
      .catch(() => {
        handleError();
      });
};

export const getUserInfoActionCreator = (
  pushToPath: (path: string) => void
) => {
  return (dispatch: TThunkDispatch) => {
    axios
      .get(API_URL + "v1/auth/state", {
        headers: getHeaderWithAuthorization(),
      })
      .then((res) => {
        dispatch(setUserName(`${res.data.firstname} ${res.data.lastname}`));
        dispatch(setUserUsername(res.data.username));
        dispatch(setUserRole(res.data.role));
        dispatch(setUserId(res.data.id));
      })
      .catch(() => {
        removeToken();
        pushToPath("/login");
      });
  };
};

export const userLogoutActionCreator = () => {
  return () => {
    removeToken();
  };
};
